import Module from './editPasswordModal'
export default Module
